import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Jedinica_mjere, ApiClientService } from '../../services/api-client.service';
import { CacheService } from '../../services/cache.service';

@Component({
  selector: 'app-jedinice-mjere',
  templateUrl: './jedinice-mjere.component.html',
  styleUrls: ['./jedinice-mjere.component.scss']
})
export class JediniceMjereComponent {
  @ViewChild('jediniceMjereGrid', { static: false }) jediniceMjereGrid: any;

  gridData: Jedinica_mjere[] = [];
  loading = false;
  isEditPopupVisible = false;
  isCreatePopupVisible = false;
  selectedJedinicaMjere: Jedinica_mjere | null = null;
  loadPanelPosition = { of: '#jediniceMjereGrid' };

  jedinicaMjereForm!: FormGroup;

  constructor(
    private apiClient: ApiClientService,
    private cache: CacheService,
    private fb: FormBuilder
  ) {
    this.initializeForm();
  }

  ngOnInit() {
    this.loadJediniceMjere();
  }

  initializeForm() {
    this.jedinicaMjereForm = this.fb.group({
      jedinica: ['', Validators.required],
      id: [this.selectedJedinicaMjere?.id || null],
      // Add other fields as needed based on your Jedinica_mjere model
    });
  }

  async loadJediniceMjere() {
    this.loading = true;
    try {
      this.gridData = await this.apiClient.jediniceMjereAll();
    } catch (error) {
      console.error('Error loading jedinice mjere:', error);
    } finally {
      this.loading = false;
    }
  }

  onRowClick(e: any) {
    if (e.data) {
      this.selectedJedinicaMjere = e.data;
    }
  }

  onAddClick() {
    this.selectedJedinicaMjere = null;
    this.jedinicaMjereForm.reset();
    this.isCreatePopupVisible = true;
  }

  onEditClick() {
    if (this.selectedJedinicaMjere) {
      this.populateForm(this.selectedJedinicaMjere);
      this.isEditPopupVisible = true;
    }
  }

  // onDeleteClick() {
  //   if (this.selectedJedinicaMjere && confirm('Are you sure you want to delete this jedinica mjere?')) {
  //     this.deleteJedinicaMjere(this.selectedJedinicaMjere.id as number);
  //   }
  // }

  populateForm(jedinicaMjere: Jedinica_mjere) {
    this.jedinicaMjereForm.patchValue({
      jedinica: jedinicaMjere.jedinica,
      id: jedinicaMjere.id,
    });
  }

  async createJedinicaMjere() {
    if (this.jedinicaMjereForm.valid) {
      this.loading = true;
      try {
        const formData = this.jedinicaMjereForm.value;
        formData.id = 0; // Ensure ID is zero for creation
        await this.apiClient.jediniceMjerePOST(formData);
        this.isCreatePopupVisible = false;
        this.jedinicaMjereForm.reset();
        this.loadJediniceMjere(); // Refresh grid
      } catch (error) {
        console.error('Error creating jedinica mjere:', error);
      } finally {
        this.loading = false;
      }
    }
  }

  async updateJedinicaMjere() {
    if (this.jedinicaMjereForm.valid && this.selectedJedinicaMjere) {
      this.loading = true;
      try {
        const formData = this.jedinicaMjereForm.value;
        await this.apiClient.jediniceMjerePUT(this.selectedJedinicaMjere.id as number, formData);
        this.isEditPopupVisible = false;
        this.loadJediniceMjere(); // Refresh grid
      } catch (error) {
        console.error('Error updating jedinica mjere:', error);
      } finally {
        this.loading = false;
      }
    }
  }

  // async deleteJedinicaMjere(id: number) {
  //   this.loading = true;
  //   try {
  //     await this.apiClient.jediniceMjereDELETE(id);
  //     this.selectedJedinicaMjere = null;
  //     this.loadJediniceMjere(); // Refresh grid
  //   } catch (error) {
  //     console.error('Error deleting jedinica mjere:', error);
  //   } finally {
  //     this.loading = false;
  //   }
  // }

  onEditPopupHidden() {
    this.isEditPopupVisible = false;
    this.selectedJedinicaMjere = null;
  }

  onCreatePopupHidden() {
    this.isCreatePopupVisible = false;
  }
}
